/**
 * What a surface says when the microphone would not open, by why.
 *
 * The phone's sentences name its own Settings app; a browser's microphone is a
 * setting of the site, and a desktop may have none at all, so the refusal and
 * the missing device are the browser's own words.
 */
import { t } from '@alluzo/shared';

import { micFailureOf, type MicFailure } from './microphone';

/** The sentence for a call or a hands-free turn. */
export const micSentence = (failure: MicFailure): string => {
  switch (failure) {
    case 'mic_off':
      return t('agent.web.voice_mic_off_body');
    case 'no_mic':
      return t('agent.web.no_microphone_body');
    case 'failed':
      return t('agent.web.microphone_failed');
  }
};

/** The sentence for whatever was thrown. */
export const micSentenceOf = (error: unknown): string => micSentence(micFailureOf(error));
